import React from "react"
import { Modal, Button, Col, Row } from "react-bootstrap"

interface SetupCompleteProps {
  title: string
  url: string
  onNext: () => void
}

export default class SetupComplete extends React.PureComponent<SetupCompleteProps> {
  render() {
    return (
      <Modal.Dialog size="xl">
        <Modal.Header>
          <Modal.Title className="text-uppercase">{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row><Col><p>Your account is activated and ready for use.</p></Col></Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onNext} className="px-4">Finish</Button>
        </Modal.Footer>
      </Modal.Dialog>
    )
  }
}
